// src/parser.ts
var keyStringifyRegexp = /([=:@$/])/g;
var valueStringifyRegexp = /([&;/])/g;
var keyParseRegexp = /[=:@$]/;
var valueParseRegexp = /[&;]/;
function encodeString(str, regexp) {
  return encodeURI(str.replace(regexp, "/$1"));
}
function trim(res) {
  return typeof res === "string" ? res.replace(/;+$/g, "").replace(/^\$/, "") : res;
}
function stringify(input, recursive) {
  if (!recursive) {
    return trim(stringify(input, true));
  }
  if (typeof input === "function") {
    return;
  }
  if (typeof input === "number" || input === true || input === false || input === null) {
    return ":" + input;
  }
  const res = [];
  if (Array.isArray(input)) {
    for (const elem of input) {
      typeof elem === "undefined" ? res.push(":null") : res.push(stringify(elem, true));
    }
    return "@" + res.join("&") + ";";
  }
  if (input instanceof Date) {
    return "=!Date:" + encodeString(input.toISOString(), valueStringifyRegexp);
  }
  if (typeof input === "object") {
    for (const [key, value] of Object.entries(input)) {
      const stringifiedValue = stringify(value, true);
      if (stringifiedValue) {
        res.push(encodeString(key, keyStringifyRegexp) + stringifiedValue);
      }
    }
    return "$" + res.join("&") + ";";
  }
  if (typeof input === "undefined") {
    return;
  }
  return "=" + encodeString(input.toString(), valueStringifyRegexp);
}
function parse(str) {
  if (!str.startsWith("$")) {
    str = "$" + str;
  }
  let pos = 0;
  str = decodeURI(str);
  function readToken(regexp) {
    let token = "";
    for (; pos !== str.length; ++pos) {
      if (str.charAt(pos) === "/") {
        pos += 1;
        if (pos === str.length) {
          token += ";";
          break;
        }
      } else if (str.charAt(pos).match(regexp)) {
        break;
      }
      token += str.charAt(pos);
    }
    return token;
  }
  function parseToken() {
    const type = str.charAt(pos++);
    if (type === "=") {
      const value = readToken(valueParseRegexp);
      if (value.startsWith("!Date:")) {
        return new Date(value.slice("!Date:".length));
      }
      return value;
    }
    if (type === ":") {
      const value = readToken(valueParseRegexp);
      if (value === "true") {
        return true;
      }
      if (value === "false") {
        return false;
      }
      const parsedValue = parseFloat(value);
      return isNaN(parsedValue) ? null : parsedValue;
    }
    if (type === "@") {
      const res = [];
      loop: {
        if (pos >= str.length || str.charAt(pos) === ";") {
          break loop;
        }
        while (1) {
          res.push(parseToken());
          if (pos >= str.length || str.charAt(pos) === ";") {
            break loop;
          }
          pos += 1;
        }
      }
      pos += 1;
      return res;
    }
    if (type === "$") {
      const res = {};
      loop: {
        if (pos >= str.length || str.charAt(pos) === ";") {
          break loop;
        }
        while (1) {
          var name = readToken(keyParseRegexp);
          res[name] = parseToken();
          if (pos >= str.length || str.charAt(pos) === ";") {
            break loop;
          }
          pos += 1;
        }
      }
      pos += 1;
      return res;
    }
    throw new Error("Unexpected char " + type);
  }
  return parseToken();
}

export {
  stringify,
  parse
};
